if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    async connectedCallback() {
      const connection = Symbol();
      this.connection = connection;
      const timers = [...this.querySelectorAll("silix-countdown")];
      if (timers.length) {
        // The countdown script may load after this component. Wait for its parser
        // and initial state before filtering originals, before Swiper creates clones.
        await customElements.whenDefined("silix-countdown");
        if (!this.isConnected || this.connection !== connection) return;
        customElements.upgrade(this);
        const now = Date.now();
        timers.forEach(timer => {
          if (Number.isFinite(timer.endTimestamp) && timer.endTimestamp <= now) {
            timer.closest(".m-announcement-bar__item")?.remove();
          }
        });
      }
      this.initializeAnnouncements();
    }

    disconnectedCallback() {
      this.connection = null;
      this.slider?.destroy(true, true);
      this.slider = null;
    }

    initializeAnnouncements() {
      const remaining = this.querySelectorAll(".m-announcement-bar__item").length;
      const section = this.closest(".m-announcement-bar");
      if (section && remaining === 0) {
        section.hidden = true;
        section.style.display = "none";
        document.documentElement.style.setProperty("--m-announcement-height", "0px");
      }
      const controls = this.querySelector(".m-slider-controls");
      if (controls) controls.style.display = remaining > 1 ? "" : "none";
      if (remaining > 1 && this.dataset.enableSlider === "true") this.initSlider();
      window.dispatchEvent(new Event("resize"));
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
